// src/AISDataPage.jsx

import React, { useState, useEffect } from 'react';

export default function AISDataPage() {
  const [aisData, setAisData]         = useState([]);
  const [loading, setLoading]         = useState(true);
  const [error, setError]             = useState(null);
  const [lastFetched, setLastFetched] = useState(null);

  useEffect(() => {
    async function load() {
      try {
        const res  = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/ais-data`);
        if (!res.ok) throw new Error(`AIS fetch failed: ${res.status}`);
        const json = await res.json();

        // raw array of all snapshots
        const all = json.records || [];

        // pick only the most recent snapshot per vessel
        const latestByVessel = all.reduce((map, rec) => {
          // use MMSI or IMO as unique key
          const key = rec.mmsi || rec.imo;
          const prev = map[key];
          if (
            !prev ||
            new Date(rec.fetchedAt) > new Date(prev.fetchedAt)
          ) {
            map[key] = rec;
          }
          return map;
        }, {});

        // final array of only the latest records
        const latestRecords = Object.values(latestByVessel);

        setAisData(latestRecords);

        // overall “last fetched” time (from the endpoint’s metadata)
        if (json.lastFetched) {
          setLastFetched(new Date(json.lastFetched));
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    load();
  }, []);

  if (loading) return <p>Loading AIS data…</p>;
  if (error)   return <p className="text-danger">Error: {error}</p>;

  return (
    <div>
      {/* Header with Last Fetched */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>AIS Data</h2>
        {lastFetched && (
          <small className="text-muted">
            Last fetched: {lastFetched.toLocaleString()}
          </small>
        )}
      </div>

      <div className="table-responsive">
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Name</th>
              <th>MMSI</th>
              <th>IMO</th>
              <th>Country</th>
              <th>Type</th>
              <th>Status</th>
              <th>Destination</th>
              <th>Last Port</th>
              <th>ETA UTC</th>
              <th>Draught</th>
              <th>Speed</th>
              <th>ATD UTC</th>
              <th>Course</th>
            </tr>
          </thead>
          <tbody>
            {aisData.map((v, i) => (
              <tr key={v.mmsi || v.imo || i}>
                <td>{v.name}</td>
                <td>{v.mmsi}</td>
                <td>{v.imo}</td>
                <td>{v.country}</td>
                <td>{v.typeSpecific}</td>
                <td>{v.navigationalStatus}</td>
                <td>{v.destination}</td>
                <td>{v.lastPort}</td>
                <td>{v.etaUtc}</td>
                <td>{v.draught}</td>
                <td>{v.speed}</td>
                <td>{v.atdUtc}</td>
                <td>{v.course}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
